import { QUESTION_IDS } from 'bundles/onboarding-common/constants/questionScheme';
import useUpdateDesiredSkills from 'bundles/onboarding-common/hooks/useUpdateDesiredSkills';
import useUpdateLearnerOccupationPreferences from 'bundles/onboarding-common/hooks/useUpdateLearnerOccupationPreferences';
import useUpdateUserProfile from 'bundles/onboarding-common/hooks/useUpdateUserProfile';
import type { QuestionValue } from 'bundles/onboarding-common/types';

const useGetLearnerObjectPromise = () => {
  const { updateUserProfile } = useUpdateUserProfile();
  const { updateLearnerOccupationPreferences } = useUpdateLearnerOccupationPreferences();
  const { updateDesiredSkills } = useUpdateDesiredSkills();

  const getLearnerObjectPromise = async ({
    questionValue,
    userId,
    externalId,
  }: {
    questionValue: QuestionValue | null | undefined;
    userId?: number;
    externalId?: string;
  }) => {
    switch (questionValue?.__typename) {
      case QUESTION_IDS.learningGoal:
        return updateUserProfile({ learningGoal: questionValue.value || undefined, userId, externalId });
      case QUESTION_IDS.roleSelect:
      case QUESTION_IDS.roleSelectAdvancer:
        return updateLearnerOccupationPreferences(questionValue.value);
      case QUESTION_IDS.skillSelect:
        return updateDesiredSkills(questionValue.value);
      case QUESTION_IDS.jobTitle:
        return updateUserProfile({ currentOccupation: questionValue.value || undefined, userId, externalId });
      case QUESTION_IDS.educationLevel:
        return updateUserProfile({ educationLevel: questionValue.value || undefined, userId, externalId });
      default:
        return Promise.resolve();
    }
  };

  return { getLearnerObjectPromise };
};

export default useGetLearnerObjectPromise;
